function Hero() {
  return (
    <section className="relative overflow-x-hidden flex flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36">
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-hero.png"
        alt="O nas - firma Drzewus - usługi ogrodnicze i arboryście"
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
      <div className="flex flex-col items-start justify-center gap-2 z-30">
        <h1 className="text-3xl lg:text-6xl text-white">O nas</h1>
        <p className="text-white text-lg lg:text-xl max-w-[800px] text-left">
          Ogrodnictwo i związane z nim prace to wymagająca kompetencji,
          umiejętności i kompleksowego podejścia dziedzina. W naszej firmie
          znaleźć możesz pełen wachlarz usług w tym zakresie, bowiem dla naszej
          wyspecjalizowanej ekipy specjalistów nie ma zadań niemożliwych.
          Działamy z wielką pasją, jesteśmy kreatywni, a przy tym chętnie
          dzielimy się swoją wiedzą.
        </p>
      </div>
    </section>
  );
}

export default Hero;
